import { TextBlockContent, TextBlockContentSource } from "../types";

export function generateTextBlockContent(
  source: TextBlockContentSource
): TextBlockContent {
  return source;
}
